const URLs = {
  DASHBOARD: '/dashboard',
  ACCOUNT: '/account',
  SERVICES: '/services',
  SERVICES_PRODUCTS: '/services/products',
  SERVICES_PRODUCT_CREATE: '/services/products/create',
  SERVICES_PRODUCT_DETAIL: '/services/products/:prodId',
  SERVICES_LINKS: '/services/links',
  SERVICES_LINKS_CREATE: '/services/links/create',
  SERVICES_LINK_DETAIL: '/services/links/:linkId',
  SERVICES_SAMPLES: '/services/samples',
  SERVICES_SAMPLE_DETAIL: '/services/samples/:sampleId',
  SALES: '/sales',
  SALES_ORDERS: '/sales/orders',
  SALES_ORDER_DETAIL: '/sales/orders/:orderId',
  SALES_DELIVERY: '/orders/delivery',
  PARTNERS: '/partners',
  BALANCE: '/balance',
  CS: '/cs',
  CS_QNA: '/cs/qna',
  CS_QNA_DETAIL: '/cs/qna/:qnaId',
  STATISTICS: '/statistics',
  STATISTICS_SALES: '/statistics/sales',
  STATISTICS_PRODUCTS: '/statistics/products',
};

const routes = [
  // 대시보드
  {
    url: URLs.DASHBOARD,
    icon: '/media/svg/icons/Design/Component.svg',
    label: '전체 현황',
  },

  // 정보수정
  {
    url: URLs.ACCOUNT,
    icon: '/media/svg/icons/Design/Component.svg',
    label: '내 정보',
    hidden:  true,
  },

  // 서비스
  {
    url: URLs.SERVICES,
    icon: '/media/svg/icons/Clothes/Crown.svg',
    label: '서비스 관리',
    children: [
      {
        url: URLs.SERVICES_PRODUCTS,
        label: '상품 관리',
      },
      {
        url: URLs.SERVICES_LINKS,
        label: '판매(링크) 관리',
      },
      {
        url: URLs.SERVICES_SAMPLES,
        label: '샘플 신청 관리',
      }
    ]
  },

  // 주문/배송
  {
    url: URLs.SALES,
    icon: '/media/svg/icons/Shopping/Bag2.svg',
    label: '주문/배송 관리',
    children: [
      {
        url: URLs.SALES_ORDERS,
        label: '주문 관리',
      },
      // {
      //   url: URLs.SALES_DELIVERY,
      //   label: '배송 관리',
      // },
    ],
  },

  // 파트너 관리
  // 배기석 부사장님의 의견으로 공급자 관리페이지에서는 판매자 관리기능이 빠짐.
  // {
  //   url: URLs.PARTNERS,
  //   icon: '/media/svg/icons/Communication/Group.svg',
  //   label: '파트너 관리',
  // },

  // CS
  {
    url: URLs.CS,
    icon: '/media/svg/icons/Communication/Chat6.svg',
    label: 'CS 관리',
    children: [
      {
        url: URLs.CS_QNA,
        label: '구매자 문의 관리',
      },
    ]
  },

  // 정산 관리
  {
    url: URLs.BALANCE,
    icon: '/media/svg/icons/General/Star.svg',
    label: '정산 관리',
  },

  // 통계 관리
  {
    url: URLs.STATISTICS,
    icon: '/media/svg/icons/Shopping/Chart-bar1.svg',
    label: '통계 관리',
    children: [
      {
        url: URLs.STATISTICS_SALES,
        label: '매출 통계',
      },
      {
        url: URLs.STATISTICS_PRODUCTS,
        label: '상품 통계',
      },
    ]
  },
];

export {routes, URLs};
